import request, { post, get } from '@/utils/request'
import { ouchnCustom } from '../../service'

const urlGetAuthConfig = ouchnCustom + '/web/auth/getAuthConfig'
const urlSendMsgCode = ouchnCustom + '/web/auth/sendMsgCode'
const urlRegister = ouchnCustom + '/web/auth/register'
const urlLoginByAccount = ouchnCustom + '/web/auth/loginByAccount'
const urlLoginByPhone = ouchnCustom + '/web/auth/loginByPhoneNum'
const urlUpdatePassword = ouchnCustom + '/web/auth/updatePassword'
const urlLogout = ouchnCustom + '/web/auth/logout'
const urlCreateCode = ouchnCustom + '/web/qrcodeLogin/createCode'
const urlRedirect = ouchnCustom + '/web/qrcodeLogin/codeStatus'

// const url = ''

// 获取权限配置
export const apiGetAuthConfig = () => get(urlGetAuthConfig, {}, { disableToken: true })

// 获取短信验证码
export const apiSendMsgCode = (data) => get(urlSendMsgCode, data, { disableToken: true })

// 注册
export const apiRegister = (data) => post(urlRegister, data, { disableToken: true })

export const apiUpdatePwd = (data) => post(urlUpdatePassword, data, { disableToken: true })
    //app 扫码
export const apiCreateCode = (data) => get(urlCreateCode, data, { disableToken: true })
export const apiRedirect = (data) => get(urlRedirect, data, { disableToken: true })

// 登录
export const apiLogin = (type, data) => {
    return type === 'sms' ?
        post(urlLoginByPhone, data, { disableToken: true }) :
        type === 'account' ?
        post(urlLoginByAccount, data, { disableToken: true }) :
        Promise.reject({ message: '未知登录方式' })
}

// TODO:退出
export const apiLogout = () => post(urlLogout)

// TODO:获取用户详细信息
export const apiGetUserInfo = () => {
        return request({
            url: '/getUserInfo',
            method: 'get',
        })
    }
    // 判断用户密码是否需要重置
export function strategy() {
    return request({
        url: ouchnCustom + '/web/auth/strategy',
        token: true,
        method: 'GET',
    })
}

// 添加用户活跃度
export function addBehavior() {
    return request({
        url: ouchnCustom + '/web/auth/addBehavior',
        token: true,
        method: 'GET',
    })
}